// src/pages/Contact.js
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { Helmet } from "react-helmet-async";

const Contact = () => {
  const { t } = useTranslation();

  const [ime, setIme] = useState("");
  const [email, setEmail] = useState("");
  const [body, setBody] = useState("");
  const [msg, setMsg] = useState("");
  

  const handleSubmit = async (e) => {
    e.preventDefault();

    // POST podaci ka serveru
    axios.post(
    `/api/home/message`,
    { ime, email, body }   // šaljemo sva tri polja
  )
  .then(res => {
    setMsg(res.data.message);
    setIme("");
    setEmail("");
    setBody("");
  })
  .catch(err => {
    console.error(err);
    setMsg("Greška pri slanju poruke ❌");
  });
  };

  return (
    <>
    <Helmet>
      <html lang="sr" />

      {/* Title i meta description */}
      <title>Kontakt | AlphaPremiumSolutions</title>
      <meta
        name="description"
        content="Kontaktirajte AlphaPremiumSolutions – tim stručnjaka za web dizajn i razvoj modernih web aplikacija u Srbiji."
      />
      <meta
        name="keywords"
        content="kontakt, web dizajn kontakt, izrada sajtova kontakt, web razvoj kontakt, Srbija"
      />
      <meta name="author" content="AlphaPremiumSolutions" />
      <meta name="robots" content="index, follow" />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Kontakt | AlphaPremiumSolutions" />
      <meta
        property="og:description"
        content="Kontaktirajte nas za profesionalnu izradu web sajtova, SEO optimizaciju i razvoj web aplikacija u Srbiji."
      />
      <meta property="og:url" content="https://alphapremiumsolutions.com/contact" />
      <meta property="og:locale" content="sr_RS" />
      <meta property="og:image" content="https://alphapremiumsolutions.com/images/contact-og-image.jpg" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Kontakt | AlphaPremiumSolutions" />
      <meta
        name="twitter:description"
        content="Kontaktirajte AlphaPremiumSolutions – profesionalni tim za web dizajn i razvoj web aplikacija."
      />
      <meta name="twitter:image" content="https://alphapremiumsolutions.com/og-image.jpg" />

      {/* Canonical */}
      <link rel="canonical" href="https://alphapremiumsolutions.com/contact" />

      {/* JSON-LD – LocalBusiness / Contact */}
      <script type="application/ld+json">
        {`
        {
          "@context": "https://schema.org",
          "@type": ["LocalBusiness", "ProfessionalService"],
          "@id": "https://alphapremiumsolutions.com/#business",
          "name": "AlphaPremiumSolutions",
          "url": "https://alphapremiumsolutions.com",
          "logo": "https://alphapremiumsolutions.com/logo.png",
          "image": "https://alphapremiumsolutions.com/og-image.jpg",
          "description": "Kontaktirajte AlphaPremiumSolutions – stručnjaci za web dizajn, izradu sajtova i razvoj web aplikacija u Srbiji.",
          "email": "info@alphapremiumsolutions.com",
          "telephone": "+381638597131",
          "priceRange": "€€",
          "areaServed": {
            "@type": "Country",
            "name": "Serbia"
          },
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Beograd",
            "addressRegion": "RS",
            "addressCountry": "RS"
          },
          "sameAs": [
            "https://www.linkedin.com/company/alphapremiumsolutions",
            "https://www.instagram.com/alphapremiumsolutions",
            "https://www.facebook.com/alphapremiumsolutions"
          ]
        }
        `}
      </script>
    </Helmet>

    <section className="py-5">
      <div className="container">
        {/* Header */}
        <div className="text-center mb-5">
          <h2 className="fw-bold">{t("contact.t1")}</h2>
          <p className="text-muted fs-6">{t("contact.t2")}</p>
        </div>

        <div className="row g-4">
          {/* Kontakt informacije */}
          <div className="col-lg-4">
            <div className="bg-light p-4 rounded-4 shadow-sm h-100">
              <h5 className="fw-bold mb-3">Email</h5>
              <p>{t("contact.t4")}</p>

               <h5 className="fw-bold mb-3 mt-4">{t("contact.t5")}</h5>
              <p>{t("contact.t6")}</p>

              <h5 className="fw-bold mb-3 mt-4">Location</h5>
              <p>{t("contact.t8")}</p>
            </div>
          </div>

          {/* Forma */}
          <div className="col-lg-8">
            <div className="bg-light p-4 rounded-4 shadow-sm">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">{t("message_us.t2")}</label>
                   <input
                    type="text"
                    className="form-control"
                    placeholder="name"
                    value={ime}
                    onChange={(e) => setIme(e.target.value)}
                    required
                    />
                </div>

                <div className="mb-3">
                  <label className="form-label">{t("message_us.t4")}</label>
                                    <input
                                      type="email"
                                      className="form-control"
                                      placeholder="you@email.com"
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      required
                                    />
                </div>

                <div className="mb-3">
                  <label className="form-label">{t("message_us.t6")}</label>
                                    <textarea
                                      className="form-control"
                                      placeholder="Your message..."
                                      value={body}
                                      onChange={(e) => setBody(e.target.value)}
                                      rows={4}
                                      required
                                    />
                </div>

                <button type="submit" className="btn btn-primary">
                  {t("message_us.t8")}
                </button>

                {msg && <small className="text-50 d-block mt-2">{msg}</small>}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default Contact;